import template from './create_cycle.html';
import * as Utils from '../../lib/savanna_utils.js';

class CreateCycleViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.performance_cycle_id = ko.observable();
		this.date = ko.observable(moment().format('YYYY-MM-DD hh:mm'));
		this.departments = ko.observableArray();
		this.selected_department = ko.observable();
		this.companies = ko.observableArray();
		this.selected_company = ko.observable();
		this.title = ko.observable();
		this.cycle_name = ko.observable();
		this.from_date = ko.observable();
		this.to_date = ko.observable();
		this.company_id = ko.observable();
		this.selected_cycle = ko.observable();
		this.performance_cycles_steps = ko.observableArray();
		this.add_predefined = ko.observable(false);
		this.add_default = ko.observable(true);

		this.view_date = ko.computed(() => {
			return 'View/Print Date:  ' + this.date();
		});

		this.company_changed = ko.computed(() => {
			if (this.selected_company() === this.company_id())
				return false;
			else
				return true;
		});

		this.selected_company.subscribe((val) => {
			if (this.selected_company() && this.company_changed())
				this.dialog.updateData();
		});

		this.selected_cycle.subscribe((val) => {
			if (this.selected_cycle())
				this.add_default(false);
		});

		this.add_default.subscribe((val) => {
			if (val ===  true)
				this.selected_cycle(null);
		});
	};

	close()
	{
		this.dialog.close();
	}

	async btn_save_cycle()
	{
		let predefined;
		if ((this.selected_cycle() || this.add_default()) && this.add_predefined())
			predefined = true;
		else
			predefined = false;

		if (!this.cycle_name())
		{
			Grape.alerts.alert({ type: 'warning', message: "Performance Cycle's name cannot be empty!"});
			return;
		}
		else
		{
			try {
				let res = await Grape.fetches.postJSON('/performance_management/cycle/edit', {
					cycle_id: this.performance_cycle_id(),
					cycle_name: this.cycle_name(),
					department_id: this.selected_department(),
					company_id: this.selected_company(),
					from_date: this.from_date(),
					to_date: this.to_date(),
					predefined: predefined,
					template: this.selected_cycle(),
					action: 'edit'
				});
				if (res.status != 'ERROR')
				{
					Grape.alerts.alert({type: 'success', message: 'Performance cycle saved successfully!'});
					this.dialog.close();
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({ type: 'error', message: 'An error occurred - ', error});
			}
		}
	}
};

class CreateCyclePage
{
	constructor (bindings)
	{
		this.viewModel = new CreateCycleViewModel(this);
		this.bindings = bindings;
	};

	async init()
	{
		Utils.refresh_data_visible_roles();

		try {
			let res = await Grape.fetches.getJSON('/api/record', {
				table: 'company',
				schema: 'public'
			});
			if (res.status != 'ERROR')
			{
				this.viewModel.companies(res.records);
			}
		} catch(error)
		{
			console.error(error);
			Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading companies'});
		}

		if (this.bindings.data)
			if (this.bindings.edit === true)
			{
				this.viewModel.company_id(this.bindings.data.company_id);
				this.viewModel.title('Edit Performance Cycle');
				this.viewModel.performance_cycle_id(this.bindings.data.performance_cycle_id);
				this.viewModel.cycle_name(this.bindings.data.cycle_name);
				this.viewModel.to_date(this.bindings.data.to_date);
				this.viewModel.from_date(this.bindings.data.from_date);
				this.viewModel.selected_company(this.bindings.data.company_id);
				await this.updateData();
				this.viewModel.selected_department(this.bindings.data.department_id);
			}
			else
				this.viewModel.title('Add Performance Cycle');
	}

	async updateData()
	{
		if (this.viewModel.selected_company())
		{
			try {
				let res = await Grape.fetches.getJSON('/api/record', {
					table: 'v_department_company',
					schema: 'savanna',
					filter: [{
						field: 'company_id',
						operand: '=',
						value: this.viewModel.selected_company()
					}]
				})
				if (res.status != 'ERROR')
				{
					this.viewModel.departments(res.records);
				}
			} catch (error) {
				console.error(error);
				Grape.alerts.alert({type: 'error', title: 'error', message: 'An error occurred while loading departments'});
			}
		}
		
		let options = {
			table: 'v_performance_cycles',
			schema: 'perfm_manage'
		}

		try {
			let res = await Grape.fetches.getJSON('/api/record', options)
			if (res.status != 'ERROR')
				this.viewModel.performance_cycles_steps(res.records);
			else 
				Grape.alerts.alert({type: 'error', message: 'An Error occurred while loading performance cycles for stages templates.'});

		} catch (error) {
			console.error(error);
		}
	}
};

export default {
	name: 'CreateCycle',
	dialog_class: CreateCyclePage,
	template: template,
	template_filename: 'translation/dialogs/create_cycle',
	provider: 'ps'
};